import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QcloudConsoleService } from '../../qcloud-console.service';

@Component({
  selector: 'lib-note-ticket-button',
  templateUrl: './note-ticket-button.component.html',
  styleUrls: ['./note-ticket-button.component.css', './../base-button/base-button.component.css']
})
export class NoteTicketButtonComponent implements OnInit {
  @ViewChild('button') public button: ElementRef;
  isEnabled: boolean;
  ticketId: number = -1;
  constructor(private consoleService: QcloudConsoleService) {
    this.consoleService.ticket.subscribe((val) => {
      if (val.id != 0 && val.id != -1) {
        this.isEnabled = true;
        this.ticketId = val.id;
      }
      else {
        this.isEnabled = false;
      }
    })
  }

  ngOnInit(): void {
  }

  public noteTicket() {
    this.consoleService.isNoteSettedToTicket(this.ticketId).subscribe((isNoteSettedToTicket) => {
      if (this.isEnabled && !isNoteSettedToTicket) {
        this.consoleService.openNoteTicketModal();
      }
    }, () => { });
  }

}